import { lightenColor } from "@/utils/lightenColor";
import React from "react";

interface SendCodeIconAttributes {
  className?: string;
  brandingColor?: string;
}

export const SendCodeIcon: React.FC<SendCodeIconAttributes> = ({
  className = "",
  brandingColor = "#22880",
}: SendCodeIconAttributes) => {
  const lighterBrandingColor = lightenColor(brandingColor, 90);
  return (
    <svg
      data-testid="secondc-code-icon"
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60 34.1121C59.2404 22.4629 51.3416 12.5036 40.1714 9.11125C29.0013 5.71888 16.8981 9.60351 9.78858 18.8629C2.67911 28.1222 2.05159 40.8181 8.21333 50.7334L0 68.0001L17.256 59.7761C20.4918 61.794 24.1064 63.1281 27.8773 63.6961"
        fill={`${lighterBrandingColor}`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66 28.1121C65.2404 16.4629 57.3416 6.50362 46.1714 3.11125C35.0013 -0.281123 22.8981 3.60351 15.7886 12.8629C8.67911 22.1222 8.05159 34.8181 14.2133 44.7334L6 62.0001L23.256 53.7761C26.4918 55.794 30.1064 57.1281 33.8773 57.6961"
        fill="white"
      />
      <path
        d="M66 28.1121C65.2404 16.4629 57.3416 6.50363 46.1714 3.11125C35.0013 -0.281123 22.8981 3.60351 15.7886 12.8629C8.67911 22.1222 8.05159 34.8181 14.2133 44.7334L6 62.0001L23.256 53.7761C26.4918 55.7941 30.1064 57.1281 33.8773 57.6961"
        stroke="#5C5C5C"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42 46C42 43.7909 43.7909 42 46 42H62C64.2091 42 66 43.7909 66 46V58C66 60.2091 64.2091 62 62 62H46C43.7909 62 42 60.2091 42 58V46Z"
        stroke={brandingColor}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54 30V30C49.5817 30 46 33.5817 46 38V42H62V38C62 33.5817 58.4183 30 54 30Z"
        stroke={brandingColor}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54 51.0774C53.4477 51.0774 53 51.5251 53 52.0774C53 52.6297 53.4477 53.0774 54 53.0774C54.5523 53.0774 55 52.6297 55 52.0774C55 51.5251 54.5523 51.0774 54 51.0774"
        stroke="#5C5C5C"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
